import { render } from "./VeterinaireForgetPassword.vue?vue&type=template&id=fa2f949a&scoped=true"
import script from "./VeterinaireForgetPassword.vue?vue&type=script&lang=js"
export * from "./VeterinaireForgetPassword.vue?vue&type=script&lang=js"

import "./VeterinaireForgetPassword.vue?vue&type=style&index=0&id=fa2f949a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa2f949a"]])

export default __exports__